//Removed FAQ Link from Customer Login Page
import React, { useState, useCallback, useRef } from "react";
import { Navbar, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../SignIn/styles/preLoginFaq.css";
import logo from "../../components/Assests/logo 1.png";

const faqItems = [
  { id: "multi-locations", question: "How do I register for multiple locations?", answer: "Under the hamburger menu on the left side of the page, select the Gear icon for Settings. On the top right side of the page, select the \"Add Location\" option. Complete the required fields and click \"Add Location\" to commit the entry." },
  { id: "sales-rep", question: "Who is my Sales Representative?", answer: "If you do not know who your Sales Representative is, please call (888) 403-0074." },
  { id: "submit-sample", question: "How do I submit a sample?", answer: "Under the hamburger menu on the left side of the page, select the Request Feed Assay icon. Complete the required fields including Customer Sample ID, Product Type, Expected Level, Units, and Phibro Lots. Select Add More Samples to enter multiple requests. Review all entries and click Submit to finalize the request." },
  { id: "results", question: "Where do I find my results?", answer: "Under the hamburger menu on the left side of the page, select the Reports icon. From this page, completed samples are listed and may be searched." },
  { id: "historical-data", question: "Where is my historical data?", answer: "Access to historical data must be approved by Phibro personnel. To request this access, click on the Telephone icon on the top right side of the page to Contact Us, enter your message, and click Submit." },
  { id: "completion-time", question: "When will my sample be completed?", answer: "Typical turn-around time is 14 business days. Use the Telephone icon on the top right side of the page to Contact Us with specific questions." },
  { id: "change-info", question: "Can I change my sample information before the sample arrives at the lab?", answer: "Yes, under the hamburger menu on the left side of the page, select the Assay Request Record icon. From here, use the table or search function to locate your sample. Click on the arrow at the right side of the page to expand the request information, click the Edit button, update the necessary information in the pop-up window, and click Update to complete the action." },
  { id: "submit-info", question: "What information do I need to submit a sample?", answer: "Please provide a Unique Customer ID, Product Type, Expected level, Units, Species, and Phibro Lot Number(s)." },
  { id: "sample-status", question: "How do I view the status of my sample?", answer: "Under the hamburger menu on the left side of the page, select the Dashboard icon. Recent sample requests are listed at the bottom of this page with their status. Click the View All button to access all samples under the Assay Request Record." },
  { id: "sample-completion", question: "How do I know when my sample is completed?", answer: "You will receive an email with your report when testing is complete. Reports can also be accessed under the hamburger menu on the left side of the page by selecting the Reports icon. From this page, completed samples are listed and may be searched." },
  { id: "sample-label", question: "Do I need to include the label with my sample?", answer: "Yes, please include all sample labels with your shipment. This will ensure that the sample information is not re-entered into the system by lab personnel." },
  { id: "result-specification", question: "Is my result within specification?", answer: "Under the hamburger menu on the left side of the page, click the FAQs icon. View the list of CFR specification limits button at the top right side of the page." },
  { id: "retest-sample", question: "Is there an option to retest my sample?", answer: "Please contact the lab using the Telephone icon at the top right side of the page to contact the lab regarding your specific sample." },
  { id: "incorrect-info", question: "What if I've entered information about my sample incorrectly?", answer: "Sample information is available to edit until it has been received by the lab. Under the hamburger menu on the left side of the page, select the Assay Request Record icon. From here, use the table or search function to locate your sample. Click on the arrow at the right side of the page to expand the request information, click the Edit button, update the necessary information in the pop-up window, and click Update to complete the action." }
];

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M12 16L7 11L8.4 9.6L11 12.2V4H13V12.2L15.6 9.6L17 11L12 16Z" fill="currentColor" />
    <path d="M5 20V18H19V20H5Z" fill="currentColor" />
  </svg>
);

const PreLoginFaq = () => {
  const [openId, setOpenId] = useState(faqItems[0].id);
  const containerRef = useRef(null);
  const navigate = useNavigate();

  const toggle = useCallback((id) => {
    setOpenId((prev) => (prev === id ? null : id));
  }, []);

  const onKeyToggle = (e, id) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle(id);
    }
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      const idx = faqItems.findIndex((f) => f.id === id);
      const nextIdx =
        e.key === "ArrowDown"
          ? Math.min(faqItems.length - 1, idx + 1)
          : Math.max(0, idx - 1);
      containerRef.current
        ?.querySelector(`button[data-prelogin-faq-btn='${faqItems[nextIdx].id}']`)
        ?.focus();
    }
  };

  const handleDownload = (filePath, fileName) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Navbar expand="lg" className="bg-white shadow-sm">
        <div className="container-fluid px-4">
          <Navbar.Brand className="d-flex align-items-center gap-2">
            <Image
              src={logo}
              height={32}
              alt="Logo"
              style={{ cursor: "pointer" }}
              role="button"
              aria-label="Go to login page"
              onClick={() => navigate("/customer-login")}
            />
            <div className="vr mx-2 d-none d-sm-block" />
            <span
              className="fw-semibold text-dark portal-title"
              style={{ cursor: "pointer" }}
              role="button"
              aria-label="Go to login page"
              onClick={() => navigate("/customer-login")}
            >
              Feed Assay Portal
            </span>
          </Navbar.Brand>
        </div>
      </Navbar>
      
      <div className="prelogin-faq-page-wrapper">
        <div className="prelogin-faq-header-bar">
          <div className="prelogin-faq-tab active" role="tab" aria-selected="true">
            Feed Assay Portal FAQs
          </div>
          <div className="prelogin-faq-download-buttons">
            <button
              className="prelogin-dl-btn"
              onClick={() => handleDownload("/PDF/How To For Phibro Feed Assay Portal.pdf", "How to for Phibro Feed Assay Portal.pdf")}
            >
              How to for Phibro Feed Assay Portal
              <DownloadIcon />
            </button>
            <button
              className="prelogin-dl-btn"
              onClick={() => handleDownload("/PDF/CFR Specifications.pdf", "CFR Specifications.pdf")}
            >
              CFR Specifications
              <DownloadIcon />
            </button>
          </div>
        </div>
        <div className="prelogin-faq-panel">
          <div className="prelogin-faq-scroll" ref={containerRef} aria-label="Frequently Asked Questions">
            {faqItems.map((f) => {
              const open = f.id === openId;
              return (
                <div className="prelogin-faq-item" key={f.id}>
                  <button
                    data-prelogin-faq-btn={f.id}
                    id={`prelogin-faq-btn-${f.id}`}
                    aria-expanded={open}
                    aria-controls={`prelogin-faq-panel-${f.id}`}
                    className={`prelogin-faq-q-btn ${open ? "expanded" : ""}`}
                    onClick={() => toggle(f.id)}
                    onKeyDown={(e) => onKeyToggle(e, f.id)}
                  >
                    <span className="prelogin-faq-question-text">{f.question}</span>
                    <span className="prelogin-symbol-wrap">{open ? "−" : "+"}</span>
                  </button>
                  {open && (
                    <div
                      id={`prelogin-faq-panel-${f.id}`}
                      role="region"
                      aria-labelledby={`prelogin-faq-btn-${f.id}`}
                      className="prelogin-faq-answer"
                    >
                      {f.answer}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default PreLoginFaq;
